import React, { useState, Fragment } from "react";
import { ReactComponent as Logo } from "../../assets/logo.svg";
import Hamburger from "./Hamburger";
import Menu from "./Menu";
import NavLinks from "./NavLinks";
import { useMedia } from "../../hooks/media";

const Navbar = () => {
  const { screenSize } = useMedia();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isTablet = screenSize >= 768;

  return (
    <nav className="w-full">
      <div className="px-4 flex justify-between items-center nav-bar lg:container lg:m-auto">
        <Logo />
        {isTablet ? (
          <NavLinks />
        ) : (
          <Fragment>
            <Hamburger
              active={isMenuOpen}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            />
            <Menu isOpen={isMenuOpen} onSelect={() => setIsMenuOpen(false)} />
          </Fragment>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
